import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import { dataManagementApiRoutes } from 'src/constants/serviceConstants/dataManagement.apiRoutes'

// download vendor, sku, po template file (data management)
export const downloadVendorSkuPoTemplateAsync = createAsyncThunk(
  '/api/v1/data-management/download-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.downloadVendorSkuPoTemplate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// download vendor, sku, po template file (data management)
export const validateAndUploadFiles = createAsyncThunk(
  '/api/v1/data-management/validate-and-upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.validateAndUploadFiles, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// get error rows for vendor table
export const getVendorErrorRowsAsync = createAsyncThunk(
  '/api/v1/data-management/get-vendor-error-rows',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getVendorErrorRows, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get error rows & missing field count
export const getErrorAndMissingCount = createAsyncThunk(
  '/api/v1/data-management/missing-fields-rows-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      dataManagementApiRoutes?.getErrorRowsAndMissingFieldCount,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get error rows for sku table
export const getSkuErrorRowsAsync = createAsyncThunk(
  '/api/v1/data-management/get-sku-error-rows',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getSkuErrorRows, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get error rows for po table
export const getPoErrorRowsAsync = createAsyncThunk(
  '/api/v1/data-management/get-po-error-rows',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getPoErrorRows, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete the selected error rows from drawer
export const deleteErrorRowsAsync = createAsyncThunk(
  '/api/v1/data-management/delete-error-records',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.deleteErrorRecords, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get enriched vendor data
export const getVendorEnrichedDataAsync = createAsyncThunk(
  '/api/v1/data-management/get-vendor-enriched-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getVendorEnrichedData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get enriched data vendor sku
export const getSkuEnrichedDataAsync = createAsyncThunk(
  '/api/v1/data-management/get-sku-enriched-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getSkuEnrichedData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save resolved error
export const saveResolvedErrorAsync = createAsyncThunk(
  '/api/v1/data-management/save-resolved-error',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveResolvedErrorRows, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save vendors edited enriched data
export const saveVendorEditEnrichDataAsync = createAsyncThunk(
  '/api/v1/data-management/save-vendor-edit-enriched-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveVendorEditEnrichData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save vendors edited enriched data
export const saveSkuEditEnrichDataAsync = createAsyncThunk(
  '/api/v1/data-management/save-sku-edit-enriched-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveSkuEditEnrichData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get sku data for landing page
export const getSkuDataAsync = createAsyncThunk(
  '/api/v1/data-management/sku-po-landing-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getSkuData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get vendor data for landing page
export const getVendorDataAsync = createAsyncThunk(
  '/api/v1/data-management/get-vendor-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getVendorData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total sku count for landing page
export const getTotalSkuCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-sku-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getTotalSkuCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total vendor count for landing page
export const getTotalVendorCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-vendor-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getTotalVendorCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// download error file
export const downloadErrorFileAsync = createAsyncThunk(
  '/api/v1/data-management/download-error-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.downloadErrorFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    },'blob')
  },
)

// get all vendor data for edit page ( no pagination here )
export const getAllVendorDataAsync = createAsyncThunk(
  '/api/v1/data-management/get-all-vendor-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getAllVendorData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get sku data for edit page
export const getEditSkuDataAsync = createAsyncThunk(
  '/api/v1/data-management/fetch-sku-data-for-edit',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getEditSkuData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get po data for edit page
export const getEditPoDataAsync = createAsyncThunk(
  '/api/v1/data-management/fetch-po-data-for-edit',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getEditPoData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// confirm trigger enrich data
export const triggerEnrichmentAsync = createAsyncThunk(
  '/api/v1/data-management/trigger-for-enrichment',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.triggerEnrichment, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save data for edit page
export const saveEditedDataAsync = createAsyncThunk(
  '/api/v1/data-management/save-edited-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveEditedData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// abort trigger enrich data
export const abortEnrichmentAsync = createAsyncThunk(
  'api/v1/data-management/abort-enrichment-process',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.abortEnrichment, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete the selected vendor rows from edit drawer
export const deleteVendorsOnEditAsync = createAsyncThunk(
  '/api/v1/data-management/delete-vendors-edit-records',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.deleteVendorsOnEdit, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete the selected sku rows from edit drawer
export const deleteSkusOnEditAsync = createAsyncThunk(
  '/api/v1/data-management/delete-skus-edit-records',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.deleteSkusOnEdit, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete the selected po rows from edit drawer
export const deletePoOnEditAsync = createAsyncThunk(
  '/api/v1/data-management/delete-pos-edit-records',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.deletePosOnEdit, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// skip enriched data review
export const skipEnrichReviewAsync = createAsyncThunk(
  '/api/v1/data-management/reset-enriched-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.skipEnrichReview, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// show enrichment progress status
export const showEnrichmentProgressAsync = createAsyncThunk(
  '/api/v1/data-management/show-enrichment-progress',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.showEnrichmentProgress, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// data adls sas url for files upload
export const getAdlsSasUrlAsync = createAsyncThunk(
  '/api/v1/data-management/get-adls-saas-url',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.getAdlsSasUrl, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// show validation progress status
export const showFileValidationProgressAsync = createAsyncThunk(
  '/api/v1/data-management/get-upload-percentage',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.showFileValidationProgress, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// cancel validations
export const cancelValidationsAync = createAsyncThunk(
  '/api/v1/data-management/cancel-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.cancelValidations, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// get taxonomy vendorsId and skuId options
export const getTaxonomyVendorSkuIdOptionsAsync = createAsyncThunk(
  '/api/v1/data-management/get-options-for-edit',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      dataManagementApiRoutes?.getTaxonomyVendorSkuIdOptions,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
// get filters for data management
export const getFiltersDataManagementAsync = createAsyncThunk(
  '/api/v1/data-management/get-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getHtsCodeAsync = createAsyncThunk(
  '/api/v1/data-management/get-hts-code-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getHtCode, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getEnrichContextAsync = createAsyncThunk(
  '/api/v1/data-management/get-enrich-context',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.getEnrichContext, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total po count for landing page
export const getTotalPoCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-po-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getTotalPoCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total vendor error count for landing page
export const getTotalVendorErrorCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-vendor-error-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getVendorErrorCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total sku error count for landing page
export const getTotalSkuErrorCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-sku-error-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getSkuErrorCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total po error count for landing page
export const getTotalPoErrorCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-po-error-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getPoErrorCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// get total vendor enrich count for landing page
export const getTotalVendorEnrichCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-vendor-enrich-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getVendorEnrichCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// get total sku enrich count for landing page
export const getTotalSkuEnrichCountAsync = createAsyncThunk(
  '/api/v1/data-management/get-total-sku-enrich-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.getSkuEnrichCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get is skip enrich status
export const getIsSkipEnrich = createAsyncThunk(
  dataManagementApiRoutes?.getIsSkipEnrich,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.getIsSkipEnrich, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)


// save is skip enrich status
export const saveIsSkipEnrich = createAsyncThunk(
  dataManagementApiRoutes?.saveIsSkipEnrich,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveIsSkipEnrich, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getEnrichedConfidenceScore = createAsyncThunk(
  dataManagementApiRoutes?.getEnrichedConfidenceScore,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.getEnrichedConfidenceScore, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const skipReviewEnrichedLater = createAsyncThunk(
  dataManagementApiRoutes?.skipReviewEnrichedLater,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', dataManagementApiRoutes?.skipReviewEnrichedLater, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const saveEnrichedData = createAsyncThunk(
  dataManagementApiRoutes?.saveEnrichedData,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', dataManagementApiRoutes?.saveEnrichedData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)